module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmNpcmNsZS1vcmFuZ2U8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNMzQsNjZBMzIsMzIsMCwxLDEsNjYsMzQsMzIsMzIsMCwwLDEsMzQsNjZaTTM0LDZBMjgsMjgsMCwxLDAsNjIsMzQsMjgsMjgsMCwwLDAsMzQsNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0yKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/circle-orange.svg
// module id = sHTd
// module chunks = 0